import {
    Component,
    EventEmitter,
    Injector,
    Output,
    ViewChild,
    OnInit,
    Input,
  } from '@angular/core';
  import { AppConsts } from '@shared/AppConsts';
  import { AppComponentBase } from '@shared/common/app-component-base';
  import {
    ProfileServiceProxy,
    StaffsAndUsersServiceProxy,
  } from '@shared/service-proxies/service-proxies';
  import { ModalDirective } from 'ngx-bootstrap/modal';
  
  @Component({
    selector: 'mySettingsManualModal',
    templateUrl: './my-settings-manual-modal.component.html',
  })
  export class MySettingsManualModalComponent
    extends AppComponentBase
    implements OnInit {
    @ViewChild('mySettingsManualModal', { static: true }) modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
    @Input() isOnboardingCompleted: Boolean;
    @Input() isMyProfileEdit: Boolean;

    public active = false;
    public saving = false;
  
    public user;
  
    isMultiTenancyEnabled: boolean = this.multiTenancy.isEnabled;
    isTwoFactorLoginEnabledForApplication = false;
  
    constructor(
      injector: Injector,
      private _profileService: ProfileServiceProxy,
      private _staffsAndUsersService: StaffsAndUsersServiceProxy
    ) {
      super(injector);
    }
  
    ngOnInit(): void {
     
    }
  
    show(): void {
      this.active = true;
  
      this._staffsAndUsersService
        .getMyOwnStaffUserForEdit()
        .subscribe((result) => {
          this.user = result;
          this.modal.show();
        });
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
  }
  